module.exports = __webpack_public_path__ + "static/media/who-we-are-image.0d16309a.jpg";